module.exports = __webpack_public_path__ + "static/media/Drilbur_gaussian2.af571126.png";